import { DomainConfig } from '../types'

export type CountryOverride = Pick<DomainConfig, 'APP_KEY' | 'CLIENT_ID'>

export const DEFAULT_COUNTRY = 'zw'

// Selector-driven multi-country deployment hosts. Each points its selector at the
// matching backend: the prod host uses prod API/MQTT, the dev host uses dev API/MQTT.
export const PROD_SELECTOR_HOST = 'pos.prod.t-soft.io'
export const DEV_SELECTOR_HOST = 'pos.dev.t-soft.io'

// Country -> { APP_KEY, CLIENT_ID }, kept per-environment because the dev and prod
// backends assign different client ids to some tenants. CLIENT_ID is the value that
// matters at runtime (API scoping via the sbe-client-id header, MQTT topics, bet
// placement); APP_KEY is currently informational (not read anywhere). Values verified
// against each environment's identity-service.clients table.
//
// Divergences: Lesotho is client 3 in prod but 4 in dev; Testovia is a dev-only test
// tenant with no prod client; Zimbabwe's group key is BWN in prod, BMW in dev.
export const PROD_COUNTRY_OVERRIDES: Record<string, CountryOverride> = {
  zw: { APP_KEY: 'BWN', CLIENT_ID: '1' },
  et: { APP_KEY: 'ETK', CLIENT_ID: '2' },
  ls: { APP_KEY: 'LSK', CLIENT_ID: '3' },
  sn: { APP_KEY: 'SNG', CLIENT_ID: '5' },
  jo: { APP_KEY: 'JOR', CLIENT_ID: '6' },
  gm: { APP_KEY: 'GMB', CLIENT_ID: '7' },
  sl: { APP_KEY: 'SLE', CLIENT_ID: '8' },
  gw: { APP_KEY: 'GWB', CLIENT_ID: '9' },
  nvw: { APP_KEY: 'NVW', CLIENT_ID: '10' },
  zm: { APP_KEY: 'ZMB', CLIENT_ID: '12' },
  lb: { APP_KEY: 'B2B', CLIENT_ID: '13' },
  bwc: { APP_KEY: 'BWC', CLIENT_ID: '14' },
  t3b: { APP_KEY: 'T3B', CLIENT_ID: '15' },
  lr: { APP_KEY: 'LBR', CLIENT_ID: '16' }
}

export const DEV_COUNTRY_OVERRIDES: Record<string, CountryOverride> = {
  zw: { APP_KEY: 'BMW', CLIENT_ID: '1' },
  et: { APP_KEY: 'ETK', CLIENT_ID: '2' },
  ls: { APP_KEY: 'LSK', CLIENT_ID: '4' },
  sn: { APP_KEY: 'SNG', CLIENT_ID: '5' },
  jo: { APP_KEY: 'JOR', CLIENT_ID: '6' },
  gm: { APP_KEY: 'GMB', CLIENT_ID: '7' },
  sl: { APP_KEY: 'SLE', CLIENT_ID: '8' },
  gw: { APP_KEY: 'GWB', CLIENT_ID: '9' },
  nvw: { APP_KEY: 'NVW', CLIENT_ID: '10' },
  tst: { APP_KEY: 'TST', CLIENT_ID: '11' },
  zm: { APP_KEY: 'ZMB', CLIENT_ID: '12' },
  lb: { APP_KEY: 'B2B', CLIENT_ID: '13' },
  bwc: { APP_KEY: 'BWC', CLIENT_ID: '14' },
  t3b: { APP_KEY: 'T3B', CLIENT_ID: '15' },
  lr: { APP_KEY: 'LBR', CLIENT_ID: '16' }
}

// Display names for every country the selector can offer. The actual options shown are
// filtered per-host to those configured for the active environment (see getCountryOptions).
export const COUNTRY_OPTIONS = [
  { id: 'zw', name: 'Zimbabwe' },
  { id: 'et', name: 'Ethiopia' },
  { id: 'ls', name: 'Lesotho' },
  { id: 'sn', name: 'Senegal' },
  { id: 'jo', name: 'Jordan' },
  { id: 'gm', name: 'Mellybet Gambia' },
  { id: 'sl', name: 'Sierra Leone' },
  { id: 'gw', name: 'Guinea Bissau' },
  { id: 'nvw', name: 'Novawin' },
  { id: 'tst', name: 'Testovia' },
  { id: 'zm', name: 'Zambia' },
  { id: 'lb', name: 'Lebanon' },
  { id: 'bwc', name: 'Bwinners.com' },
  { id: 't3b', name: 'T3bet' },
  { id: 'lr', name: 'Mellybet Liberia' }
]
